import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useAuth } from '~/hooks';
import CompaniesArea from './companies/CompaniesArea';
import OpportunitiesArea from './opportunities/OpportunitiesArea';
import ContactsArea from './contacts/ContactsArea';

export default function PipelineArea() {
  const { path, url } = useRouteMatch();
  const auth = useAuth();

  return (
    <Switch>
      {/* The sidebar hides each list item behind its own view scope, so the routes stay open — a
          direct URL runs authorize() and comes back empty rather than 403. */}
      <Route path={`${path}/opportunities`}>
        <OpportunitiesArea />
      </Route>

      <Route path={`${path}/companies`}>
        <CompaniesArea />
      </Route>

      <Route path={[`${path}/contacts`]}>
        <ContactsArea />
      </Route>

      <Redirect
        path="/"
        to={
          auth.opportunities.view
            ? `${url}/opportunities`
            : auth.companies.view
              ? `${url}/companies`
              : `${url}/contacts`
        }
      />
    </Switch>
  );
}
